// extracted by mini-css-extract-plugin
export var caretAnchor = "_va-0";
export var dropdownContent = "_va-1";